import TomSelect from 'tom-select';
import 'tom-select/dist/css/tom-select.bootstrap5.min.css';

const categorySelector = '[data-directory-category-select]';

function clearDirectoryCategorySelect() {
    document.querySelectorAll(categorySelector).forEach((element) => {
        const select = element.tomselect;

        if (select) {
            select.clear();
        }

        element.querySelectorAll('option').forEach((option) => {
            option.selected = false;
        });
    });
}

function initializeDirectoryCategorySelect() {
    document.querySelectorAll(categorySelector).forEach((element) => {
        if (element.tomselect) {
            return;
        }

        new TomSelect(element, {
            plugins: ['remove_button'],
            persist: false,
            create: false,
            closeAfterSelect: false,
            placeholder: element.dataset.placeholder || 'Search and select categories',
            onChange(value) {
                const componentElement = element.closest('[wire\\:id]');
                const componentId = componentElement?.getAttribute('wire:id');
                const component = componentId ? window.Livewire.find(componentId) : null;

                component?.set('categoryIds', Array.isArray(value) ? value : (value ? [value] : []));
            },
        });
    });
}

document.addEventListener('livewire:init', () => {
    initializeDirectoryCategorySelect();

    window.Livewire.on('directory-filters-cleared', () => {
        clearDirectoryCategorySelect();
    });
});

document.addEventListener('DOMContentLoaded', initializeDirectoryCategorySelect);
document.addEventListener('livewire:navigated', initializeDirectoryCategorySelect);
